import React, { useState, useEffect } from 'react';

const COOKIE_KEY = 'robotbeheer_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const val = localStorage.getItem(COOKIE_KEY);
      if (!val) setVisible(true);
    } catch {
      // If localStorage is unavailable, still show banner once per session
      setVisible(true);
    }
  }, []);

  function accept() {
    try {
      localStorage.setItem(COOKIE_KEY, '1');
    } catch (e) {
      // localStorage may be unavailable in some environments (incognito, strict privacy).
      // Swallow the error but keep a lightweight debug log for diagnostics.

      console.debug('CookieBanner: failed to write consent to localStorage', e);
    }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div style={bannerStyle} role="dialog" aria-live="polite">
      <div style={{flex: 1}}>
        Deze website gebruikt cookies om de volledige werking te garanderen. Door op de website te blijven accepteer je de cookies.
      </div>
      <div style={{marginLeft: 'var(--space-12)'}}>
        <button onClick={accept} style={btnStyle}>Akkoord</button>
      </div>
    </div>
  );
}

const bannerStyle = {
  position: 'fixed',
  left: 'var(--space-12)',
  right: 'var(--space-12)',
  bottom: 'var(--space-12)',
  zIndex: 2000,
  background: 'rgba(0,0,0,0.85)',
  color: 'var(--neutral-0)',
  padding: 'var(--space-12) var(--space-16)',
  borderRadius: 'var(--space-8)',
  display: 'flex',
  alignItems: 'center',
  boxShadow: '0 4px 16px rgba(0,0,0,0.4)'
};

const btnStyle = {
  background: 'var(--success)',
  color: 'var(--neutral-0)',
  border: 'none',
  padding: 'var(--space-8) var(--space-12)',
  borderRadius: '6px',
  cursor: 'pointer'
};
